import { render } from "./Create.vue?vue&type=template&id=ec15b49c&bindings={\"errors\":\"props\",\"teachers\":\"props\",\"courses\":\"props\",\"form\":\"data\",\"create\":\"options\"}"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "ec15b49c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ec15b49c')) {
    api.reload('ec15b49c', script)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=ec15b49c&bindings={\"errors\":\"props\",\"teachers\":\"props\",\"courses\":\"props\",\"form\":\"data\",\"create\":\"options\"}", () => {
    api.rerender('ec15b49c', render)
  })

}

script.__file = "resources/js/Pages/Classrooms/Create.vue"

export default script